import React from 'react'

import {
    useHistory
} from 'react-router-dom'

import { 
    BlueTint 
} from '../../Styles/BaseStyles'

import {
    SOCDiv,
    SOCComponentsDiv,
    QuickFillerButtonDiv,
    SOCConfirmationDiv,
    TitleIconButton,
    QuickFillerButton,
    SOCConfirmationTitle,
    SOCConfirmationPhrase,
    SOCConfirmationExitPhrase
} from '../../Styles/Components/SignUpConfirmStyles'

import { useSelector } from 'react-redux'

function SignUpConfirm(props){
    let history = useHistory()
    const email = useSelector(state => state.signUp.email)

    function mainPage(e){
        history.push('/')
    }

    return (
        <SOCDiv id="signup-confirm-section">
            <SOCComponentsDiv>
                <SOCConfirmationDiv>
                    <QuickFillerButtonDiv>
                        <TitleIconButton />
                        <QuickFillerButton onClick={mainPage}><BlueTint>Q</BlueTint>uick<BlueTint>F</BlueTint>iller</QuickFillerButton>
                    </QuickFillerButtonDiv>
                    <SOCConfirmationTitle>Sign Up Success!</SOCConfirmationTitle>
                    <SOCConfirmationPhrase>QuickFiller account for {email} successfully created.</SOCConfirmationPhrase>
                    <SOCConfirmationExitPhrase>Please exit this tab and follow the steps in your email.</SOCConfirmationExitPhrase>
                </SOCConfirmationDiv>
            </SOCComponentsDiv>
        </SOCDiv>
    )
}

export default SignUpConfirm